<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="sign__page">
          <div class="sign__page">
            <div class="form">
              <ul class="form__ul">
                <li class="form__li">
                  <div class="form__ttl">서비스 선택</div>
                  <div class="form__in">
                    <div class="inline">
                      <label class="input">
                        <select v-model.trim="params.serviceType">
                          <option v-for="(item, index) in $ConstCode.CODE_SERVICE_TYPE" :key="index" :value="item.value">{{ item.label }}</option>
                        </select>
                      </label>
                    </div>
                  </div>
                </li>
                <li class="form__li">
                  <div class="form__ttl">회사명<span class="required"> *</span></div>
                  <div class="form__in">
                    <div class="inline flex_hint">
                      <label class="input">
                        <input type="text" :class="{'is-invalid': $v.params.companyName.$error}" placeholder="회사명을 입력해주세요."
                               v-model.trim="params.companyName"
                               maxlength="15">
                      </label>
                      <div class="hint on" v-show="$v.params.companyName.$error">{{ valid.msg.required }}</div> <!-- on -->
                    </div>
                  </div>
                </li>
                <li class="form__li">
                  <div class="form__ttl">이름<span class="required"> *</span></div>
                  <div class="form__in">
                    <div class="inline flex_hint">
                      <label class="input">
                        <input type="text" :class="{'is-invalid': $v.params.name.$error}" placeholder="이름을 입력해주세요." v-model.trim="params.name"
                               maxlength="15">
                      </label>
                      <div class="hint on" v-show="$v.params.name.$error">{{ valid.msg.required }}</div> <!-- on -->
                    </div>
                  </div>
                </li>
                <li class="form__li">
                  <div class="form__ttl">전화번호<span class="required"> *</span></div>
                  <div class="form__in">
                    <div class="inline flex_hint">
                      <label class="input">
                        <input type="text" :class="{'is-invalid': $v.params.tel.$error}" placeholder="전화번호를 입력해주세요." v-model.trim="params.tel"
                               maxlength="15">
                      </label>
                      <div class="hint on" v-show="$v.params.tel.$error">{{ valid.msg.required }}</div> <!-- on -->
                    </div>
                  </div>
                </li>
                <li class="form__li">
                  <div class="form__ttl">E-Mail<span class="required"></span></div>
                  <div class="form__in">
                    <div class="inline flex_hint">
                      <label class="input">
                        <input type="text" placeholder="E-Mail을 입력해주세요." v-model.trim="params.email" maxlength="32">
                      </label>
                    </div>
                  </div>
                </li>
                <li class="form__li">
                  <div class="form__ttl">접한 곳<span class="required"></span></div>
                  <div class="form__in">
                    <div class="inline flex_hint">
                      <label class="input">
                        <input type="text" placeholder="이름을 입력해주세요." v-model.trim="params.hearPlace" maxlength="128">
                      </label>
                    </div>
                  </div>
                </li>
                <li class="form__li">
                  <div class="form__ttl">내용<span class="required"></span></div>
                  <div class="form__in">
                    <div class="inline flex_hint">
                      <label class="input">
                        <textarea placeholder="내용을 입력해주세요." v-model="params.description"></textarea>
                      </label>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="btn_wrap btn_wrap__fixed">
        <button class="btm" :class="'on'" @click="registInquire">문의등록</button> <!--활성화: on-->
      </div>
    </div>
  </main>
</template>
<script>
import required from "vuelidate/lib/validators/required";

export default {
  data: function () {
    return {
      valid: {
        msg: {
          required: '필수 입력 항목입니다.',
        }
      },
      params: {
        serviceType : this.$ConstCode.CODE_SERVICE_TYPE.ELECT.value,
        companyName: '',
        name: '',
        tel: '',
        email: '',
        hearPlace: '',
        description: ''
      }
    }
  },
  validations: {
    params: {
      companyName: {
        required
      },
      name: {
        required
      },
      tel: {
        required
      }
    }
  },
  methods: {
    registInquire: async function () {
      this.$v.$touch();
      if (!this.$Util.isValid(this.$v, this.$el)) {
        return false
      }

      const res = await this.$AccountSvc.registInquire(this.params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.$Util.modalAlert({message: '등록되었습니다.'}, function () {
          this.$router.go(-1)
        })
      } else {
        this.$Util.modalAlert({message: message})
      }
    }
  }
}
</script>

<style lang="scss">
  .form__in .inline select {
    border-radius: 0.4rem;
    padding: 1.2rem 1rem;
    border: none;
    color: #616161;
    background: #F5F5F5;
    font-size: 1.4rem;
    -webkit-appearance: auto !important;
  }
</style>
